import i18next from "i18next";
import { initReactI18next } from "react-i18next";

//Import all translation files
import de_translation from "./translations/de.json";
import fr_translation from "./translations/fr.json";
import it_translation from "./translations/it.json";

const resources = {
  de: {
    translation: de_translation,
  },
  fr: {
    translation: fr_translation,
  },
  it: {
    translation: it_translation,
  },
};

i18next.use(initReactI18next).init({ resources, lng: "de" });

export default i18next;
